import { render } from "./Check.vue?vue&type=template&id=e3e962d0"
const script = {}
script.render = render

export default script